import { defineMessages } from "react-intl"

// Global / Shared messages should go here
export const messages = defineMessages({
  archive: {
    id: "resource.archive",
    defaultMessage: "Archive"
  },
  digitisationID: {
    id: "resource.digitisation_id",
    defaultMessage: "Digitisation ID"
  },
  format: {
    id: "resource.format",
    defaultMessage: "Format"
  },
  findingAidChildren: {
    id: "resource.finding_aid_children",
    defaultMessage: "Finding aid children"
  },
  findingAidParent: {
    id: "resource.finding_aid_parents",
    defaultMessage: "Finding aid parents"
  },
  heldIn: {
    id: "resource.held_in",
    defaultMessage: "Held In"
  },
  objectType: {
    id: "resource.object_type",
    defaultMessage: "Object type"
  },
  relation: {
    id: "resource.relation",
    defaultMessage: "Relation"
  },
  title: {
    id: "resource.title",
    defaultMessage: "Title"
  },
  location: {
    id: "resource.location",
    defaultMessage: "Location"
  },
  identification: {
    id: "resource.identification",
    defaultMessage: "Identification"
  },
  relatedItems: {
    id: "resource.related_items",
    defaultMessage: "Related items"
  },
  editItem: {
    id: "resource.edit-item",
    defaultMessage: "Edit item"
  },
  showImage: {
    id: "resource.show-image",
    defaultMessage: "Show Image"
  },
  imagePosition: {
    id: "resource.image-position",
    defaultMessage: "Image {position}"
  },
  userComments: {
    id: "resource.user-comments",
    defaultMessage: "User comments"
  }
})

export default messages



// WEBPACK FOOTER //
// ./webapp/messages/resource.js